import TopicsPageV2 from './TopicsPageV2'

export default TopicsPageV2
// eslint-disable-next-line import/export
export * from './TopicsPageV2'
